import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";
import {Price} from "../../../services/currency/price";

interface TicketJourneyPassengerTypeCartComponentProps {
    description: string;
    fareQuantity: number;
    totalFareToDisplay: Price;
    isLastOne: boolean;
}

export const TicketPassengerTypeCartComponent: React.FC<TicketJourneyPassengerTypeCartComponentProps> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        pageBreakInside: 'avoid',
        breakInside: 'avoid'
    }

    if(!props.isLastOne) {
        styles.borderBottom = `1px solid ${theme.border.mainColor}`;
        styles.paddingBottom = theme.spacing.flexGap12;
    }

    return (
        <div style={styles}>
            <div>
                {`${props.fareQuantity} x ${props.description}` }
            </div>
            <div>
                {props.totalFareToDisplay.toString()}
            </div>
        </div>
    )
})

